(() => {
  const centreScrollArea = (scrollArea) => {
    scrollArea.scrollLeft = Math.max(0, (scrollArea.scrollWidth - scrollArea.clientWidth) / 2);
  };

  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-headliner-body-image-scroll], [data-headliner-body-scroll]').forEach((scrollArea) => {
      if (scrollArea.dataset.headlinerBodyImageScrollReady) return;
      scrollArea.dataset.headlinerBodyImageScrollReady = 'true';

      requestAnimationFrame(() => centreScrollArea(scrollArea));
      window.addEventListener('load', () => centreScrollArea(scrollArea), { once: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialise());
  } else {
    initialise();
  }

  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
